module.exports = __webpack_public_path__ + "media/images/default/pages/about/33676-b0e40a6672e3ba55380b0a062b4c074b.svg";